<template>
<div class="popHeaderOrderList pop-np-user" v-if="centerDialogVisible">
    <el-dialog title="队长订单" :visible.sync="centerDialogVisible" width="720px" center>
        <div class="title">
            <div class="box">用户昵称：{{userinfo.customername}} <img :src="userinfo.customericonurl " alt="" class="img"></div>
            <div class="box">总订单数：{{userinfo.totalordercount}}</div>
            <div class="box">队长总奖励：￥{{userinfo.totalbrokerage}}</div>
        </div>
        <div class="result-list btn-operate-list">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="orderno" label="购买用户">
                    <template slot-scope="scope">
                        <div class="imgtext">
                            <img :src="scope.row.customericonurl" alt="" class="img">
                            <span>{{scope.row.customername}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="finalpaymoney" label="订单金额" width="80">
                    <template slot-scope="scope">￥{{scope.row.finalpaymoney}}</template>
                </el-table-column>
                <el-table-column prop="datetime" label="订单时间" width="150"></el-table-column>
                <el-table-column prop="brokerage" label="队长奖励" width="80">
                    <template slot-scope="scope">￥{{scope.row.brokerage}}</template>
                </el-table-column>
            </el-table>
            <dialogPage :total="total" @getList="_getList" ref="dialogPage"></dialogPage>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {getOrderListByEventHeader} from 'api/nationalDistribution'
import {mapGetters, mapActions} from 'vuex'
import DialogPage from 'base/page/dialogPage'
export default {
    name: 'popHeaderOrderList',
    data() {
        return {
            centerDialogVisible: false,
            param: {
                eventinnerid: '',
                disuserid: ''
            },
            userinfo: {},
            tableData: [],
            total: 0
        }
    },
    mounted() {
    },
    methods: {
        open(obj) {
            this.centerDialogVisible = true
            this.param.eventinnerid = obj.eventinnerid
            this.param.disuserid = obj.innerid
            this.userinfo = {}
            this.tableData = []
            this.total = 0
            let dialogPage = {page: 1, pageSize: this.dialogPage.pageSize}
            this.$store.commit('SET_DIALOGPAGE', dialogPage)
            this._getList()
        },
        _getList() {
            this.setLoading(true)
            getOrderListByEventHeader({
                data: Object.assign({}, this.param, this.dialogPage),
                success: data => {
                    this.setLoading(false)
                    if (this.dialogPage.page === 1) {
                        this.userinfo = data.data.userinfo
                        this.total = data.data.pageinfo.rowCount
                    }
                    this.tableData = data.data.content
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'dialogPage'
        ])
    },
    components: {
        DialogPage
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.popHeaderOrderList {
}
</style>
